import { all } from 'redux-saga/effects';

import { auth } from '../sagas';

function* root() {
  yield all([auth()]);
}

export default root;
